import { Flex, Theme } from "@radix-ui/themes";
import { Redirect, Route, Switch } from "react-router";

import { Header } from "~/v3-poc/components/header";
import {
  AtdThemeProvider,
  useAtdThemeContext,
} from "~/v3-poc/features/user-preferences";
import { Workspace } from "~/v3-poc/features/workspace/Workspace.connector";
import { InvalidationProvider } from "~/v3-poc/kernel/react/Invalidation.context";
import { ADVANCED_TRADING_DASHBOARD_PATHS } from "./path";

import "@radix-ui/themes/styles.css";
import "../theme/theme.css";

const AdvancedTradingDashboardContent = () => {
  const { theme } = useAtdThemeContext();

  return (
    <Theme
      // Scopes ATD feature CSS (see v3-poc **/*.css).
      data-advanced-trading-dashboard=""
      appearance={theme}
      accentColor="yellow"
      grayColor="gray"
      panelBackground="solid"
      radius="small"
      scaling="95%"
      // A fixed viewport height, not a minimum: the shell owns the window's
      // height so panes scroll inside it. Without it the flex chain grows past
      // the fold and rail furniture like Settings scrolls off screen.
      className="flex h-dvh flex-col"
    >
      <Header />
      <Flex direction="column" flexGrow="1" minHeight="0">
        <Switch>
          <Route path={ADVANCED_TRADING_DASHBOARD_PATHS.LEGACY_LAYOUT_LABS}>
            <Redirect to={ADVANCED_TRADING_DASHBOARD_PATHS.ROOT} />
          </Route>
          <Route
            path={ADVANCED_TRADING_DASHBOARD_PATHS.ROOT}
            exact
            component={Workspace}
          />
        </Switch>
      </Flex>
    </Theme>
  );
};

export const AdvancedTradingDashboardRoot = () => (
  <AtdThemeProvider>
    <InvalidationProvider>
      <AdvancedTradingDashboardContent />
    </InvalidationProvider>
  </AtdThemeProvider>
);
